import * as React from "react";

function ArrowIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 14 8" fill="none" {...props}>
      <path
        d="M13 7L7 1 1 7"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const MemoArrowIcon = React.memo(ArrowIcon);
export default MemoArrowIcon;
